import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ user, children }) => {
    if (!user || user === "undefined") {
        return <Navigate to="/" replace />
    }
    return children;
}